module.exports = __webpack_public_path__ + "img/Hotmart-9-pt.454aa77e.png";